import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["defaultOpen"],
  _excluded2 = ["id"],
  _excluded3 = ["id"];
var _Q;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import E, { Fragment as F, createContext as C, useContext as I, useEffect as h, useMemo as S, useReducer as N, useRef as g } from "react";
import { match as x } from '../../utils/match.js';
import { forwardRefWithAs as L, render as O, Features as U } from '../../utils/render.js';
import { optionalRef as K, useSyncRefs as B } from '../../hooks/use-sync-refs.js';
import { useId as _ } from '../../hooks/use-id.js';
import { Keys as m } from '../keyboard.js';
import { isDisabledReactIssue7711 as G } from '../../utils/bugs.js';
import { OpenClosedProvider as j, State as R, useOpenClosed as W } from '../../internal/open-closed.js';
import { useResolveButtonType as $ } from '../../hooks/use-resolve-button-type.js';
import { getOwnerDocument as J } from '../../utils/owner.js';
import { useEvent as A } from '../../hooks/use-event.js';
import { startTransition as X } from '../../utils/start-transition.js';
var q = function (o) {
    return o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o;
  }(q || {}),
  z = function (t) {
    return t[t.ToggleDisclosure = 0] = "ToggleDisclosure", t[t.CloseDisclosure = 1] = "CloseDisclosure", t[t.SetButtonId = 2] = "SetButtonId", t[t.SetPanelId = 3] = "SetPanelId", t[t.LinkPanel = 4] = "LinkPanel", t[t.UnlinkPanel = 5] = "UnlinkPanel", t;
  }(z || {});
var Q = (_Q = {}, _defineProperty(_Q, 0, function _(e) {
    var _x;
    return _objectSpread(_objectSpread({}, e), {}, {
      disclosureState: x(e.disclosureState, (_x = {}, _defineProperty(_x, 0, 1), _defineProperty(_x, 1, 0), _x))
    });
  }), _defineProperty(_Q, 1, function _(e) {
    return e.disclosureState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
      disclosureState: 1
    });
  }), _defineProperty(_Q, 4, function _(e) {
    return e.linkedPanel === !0 ? e : _objectSpread(_objectSpread({}, e), {}, {
      linkedPanel: !0
    });
  }), _defineProperty(_Q, 5, function _(e) {
    return e.linkedPanel === !1 ? e : _objectSpread(_objectSpread({}, e), {}, {
      linkedPanel: !1
    });
  }), _defineProperty(_Q, 2, function _(e, n) {
    return e.buttonId === n.buttonId ? e : _objectSpread(_objectSpread({}, e), {}, {
      buttonId: n.buttonId
    });
  }), _defineProperty(_Q, 3, function _(e, n) {
    return e.panelId === n.panelId ? e : _objectSpread(_objectSpread({}, e), {}, {
      panelId: n.panelId
    });
  }), _Q),
  k = C(null);
k.displayName = "DisclosureContext";
function M(e) {
  var n = I(k);
  if (n === null) {
    var o = new Error("<".concat(e, " /> is missing a parent <Disclosure /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, M), o;
  }
  return n;
}
var v = C(null);
v.displayName = "DisclosureAPIContext";
function w(e) {
  var n = I(v);
  if (n === null) {
    var o = new Error("<".concat(e, " /> is missing a parent <Disclosure /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, w), o;
  }
  return n;
}
var H = C(null);
H.displayName = "DisclosurePanelContext";
function V() {
  return I(H);
}
function Y(e, n) {
  return x(n.type, Q, e, n);
}
var Z = F;
function ee(e, n) {
  var _x2;
  var _e$defaultOpen = e.defaultOpen,
    o = _e$defaultOpen === void 0 ? !1 : _e$defaultOpen,
    u = _objectWithoutProperties(e, _excluded),
    T = g(null),
    l = B(n, K(function (a) {
      T.current = a;
    }, e.as === void 0 || e.as === F)),
    t = g(null),
    f = g(null),
    s = N(Y, {
      disclosureState: o ? 0 : 1,
      linkedPanel: !1,
      buttonRef: f,
      panelRef: t,
      buttonId: null,
      panelId: null
    }),
    _s = _slicedToArray(s, 2),
    _s$ = _s[0],
    i = _s$.disclosureState,
    c = _s$.buttonId,
    D = _s[1],
    d = A(function (a) {
      D({
        type: 1
      });
      var r = J(T);
      if (!r || !c) return;
      var p = function () {
        return a ? a instanceof HTMLElement ? a : a.current instanceof HTMLElement ? a.current : r.getElementById(c) : r.getElementById(c);
      }();
      p == null || p.focus();
    }),
    P = S(function () {
      return {
        close: d
      };
    }, [d]),
    b = S(function () {
      return {
        open: i === 0,
        close: d
      };
    }, [i, d]),
    y = {
      ref: l
    };
  return E.createElement(k.Provider, {
    value: s
  }, E.createElement(v.Provider, {
    value: P
  }, E.createElement(j, {
    value: x(i, (_x2 = {}, _defineProperty(_x2, 0, R.Open), _defineProperty(_x2, 1, R.Closed), _x2))
  }, O({
    ourProps: y,
    theirProps: u,
    slot: b,
    defaultTag: Z,
    name: "Disclosure"
  }))));
}
var te = "button";
function ne(e, n) {
  var o = _(),
    _e$id = e.id,
    u = _e$id === void 0 ? "headlessui-disclosure-button-".concat(o) : _e$id,
    T = _objectWithoutProperties(e, _excluded2),
    _M = M("Disclosure.Button"),
    _M2 = _slicedToArray(_M, 2),
    l = _M2[0],
    t = _M2[1],
    f = V(),
    s = f === null ? !1 : f === l.panelId,
    i = g(null),
    c = B(i, n, s ? null : l.buttonRef);
  h(function () {
    if (!s) return t({
      type: 2,
      buttonId: u
    }), function () {
      t({
        type: 2,
        buttonId: null
      });
    };
  }, [u, t, s]);
  var D = A(function (r) {
      var p;
      if (s) {
        if (l.disclosureState === 1) return;
        switch (r.key) {
          case m.Space:
          case m.Enter:
            r.preventDefault(), r.stopPropagation(), t({
              type: 0
            }), (p = l.buttonRef.current) == null || p.focus();
            break;
        }
      } else switch (r.key) {
        case m.Space:
        case m.Enter:
          r.preventDefault(), r.stopPropagation(), t({
            type: 0
          });
          break;
      }
    }),
    d = A(function (r) {
      switch (r.key) {
        case m.Space:
          r.preventDefault();
          break;
      }
    }),
    P = A(function (r) {
      var p;
      G(r.currentTarget) || e.disabled || (s ? (t({
        type: 0
      }), (p = l.buttonRef.current) == null || p.focus()) : t({
        type: 0
      }));
    }),
    b = S(function () {
      return {
        open: l.disclosureState === 0
      };
    }, [l]),
    y = $(e, i),
    a = s ? {
      ref: c,
      type: y,
      onKeyDown: D,
      onClick: P
    } : {
      ref: c,
      id: u,
      type: y,
      "aria-expanded": e.disabled ? void 0 : l.disclosureState === 0,
      "aria-controls": l.linkedPanel ? l.panelId : void 0,
      onKeyDown: D,
      onKeyUp: d,
      onClick: P
    };
  return O({
    ourProps: a,
    theirProps: T,
    slot: b,
    defaultTag: te,
    name: "Disclosure.Button"
  });
}
var le = "div",
  oe = U.RenderStrategy | U.Static;
function re(e, n) {
  var o = _(),
    _e$id2 = e.id,
    u = _e$id2 === void 0 ? "headlessui-disclosure-panel-".concat(o) : _e$id2,
    T = _objectWithoutProperties(e, _excluded3),
    _M3 = M("Disclosure.Panel"),
    _M4 = _slicedToArray(_M3, 2),
    l = _M4[0],
    t = _M4[1],
    _w = w("Disclosure.Panel"),
    f = _w.close,
    s = B(n, l.panelRef, function (P) {
      X(function () {
        return t({
          type: P ? 4 : 5
        });
      });
    });
  h(function () {
    return t({
      type: 3,
      panelId: u
    }), function () {
      t({
        type: 3,
        panelId: null
      });
    };
  }, [u, t]);
  var i = W(),
    c = function () {
      return i !== null ? (i & R.Open) === R.Open : l.disclosureState === 0;
    }(),
    D = S(function () {
      return {
        open: l.disclosureState === 0,
        close: f
      };
    }, [l, f]),
    d = {
      ref: s,
      id: u
    };
  return E.createElement(H.Provider, {
    value: l.panelId
  }, O({
    ourProps: d,
    theirProps: T,
    slot: D,
    defaultTag: le,
    features: oe,
    visible: c,
    name: "Disclosure.Panel"
  }));
}
var se = L(ee),
  ue = L(ne),
  ie = L(re),
  ve = Object.assign(se, {
    Button: ue,
    Panel: ie
  });
export { ve as Disclosure };